var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigureCrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u56FE\u6807_\u56FE\u88C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-837.000000, -139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807_\\u56FE\\u88C2",
    transform: "translate(837.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    fill: "#C9CED4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,0 C44.7614237,0 47,2.23857625 47,5 L47,26 L42,26 L42,5 L5,5 L5,42 L26,42 L26,47 L5,47 C2.23857625,47 0,44.7614237 0,42 L0,5 C0,2.23857625 2.23857625,0 5,0 L42,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18",
    transform: "translate(32.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M13.8965473,3.88460009 L9.91372115,7.875 L5.93207155,3.88460009 L3.80826368,6.00342999 L7.79472115,9.999 L3.80826368,13.9965851 L5.93207155,16.1154149 L9.91372115,12.124 L13.8965473,16.1154149 L16.0203551,13.9965851 L12.0327211,10 L16.0203551,6.00342999 L13.8965473,3.88460009 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 10,
    y: 10,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7671695,19.5672287 L36.7669239,29.3884905 C33.0346515,30.8481291 30.1420376,33.9831537 29.0139528,37.8686939 L9.5250698,37.8684629 L18.3591914,25.5288731 L23.1461196,31.299446 L36.7671695,19.5672287 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureCrack);
export default __webpack_public_path__ + "static/media/Figure_crack.7e0774ab023520b2e5773fa143472881.svg";
export { ForwardRef as ReactComponent };